<template>

    <v-page fixed>

        <transition name="modal">
            <v-modal-property-edit v-if="showModal === 'property-edit'" :event="event" :property="property" @saved="getEvent" />
            <v-modal-property-delete v-if="showModal === 'property-delete'" :event="event" :property="property" @deleted="getEvent" />
        </transition>

        <v-page-header icon="fas fa-fire">
            <v-breadcrumb>
                <v-breadcrumb-item><router-link :to="{ name: 'events' }">Events</router-link></v-breadcrumb-item>
                <v-breadcrumb-item v-if="event">{{ event.name }}</v-breadcrumb-item>
            </v-breadcrumb>
        </v-page-header>

        <v-page-filters>
            <v-identifier v-if="event" :uuid="event.id" />
            <v-button size="sm" @click.native="updateEvent" :loading="loading">Save Event</v-button>
        </v-page-filters>

        <v-page-body>

            <v-page-section>
                <template #title>{{ event.action }}</template>
                <template #body>
                    <v-form-group label="Name">
                        <v-input class="w-300" :model="params.name" @input="params.name = $event" />
                    </v-form-group>
                    <v-form-group label="Color">
                        <v-input-color class="w-300" :model="params.color" @input="params.color = $event" />
                    </v-form-group>
                    <v-form-group label="Description">
                        <v-textarea :rows="3" :model="params.description" @input="params.description = $event" />
                    </v-form-group>
                    <v-form-group v-if="event.properties.length" label="Properties">
                        <v-list grouped>
                            <v-list-item size="sm" v-for="p in event.properties" :key="p.id">
                                <span><a href="#" @click.prevent="selectProperty(p)">{{ p.name }}</a></span>
                                <div class="d-flex align-items-center justify-content-end">
                                    <v-button size="xs" btn-style="secondary" btn-label="Edit" @click.native="selectProperty(p)">Edit</v-button>
                                </div>
                            </v-list-item>
                        </v-list>
                    </v-form-group>
                </template>
            </v-page-section>

        </v-page-body>

    </v-page>

</template>

<script>

import ModalEventPropertyDelete from '@modals/event/ModalEventPropertyDelete';
import ModalEventPropertyEdit from '@modals/event/ModalEventPropertyEdit';
import EventApi from '@api/EventApi';

export default {

    components: {
        'v-modal-property-delete': ModalEventPropertyDelete,
        'v-modal-property-edit': ModalEventPropertyEdit,
    },

    data() {
        return {
            loading: false,
            event: null,
            property: null,
            params: {},
        }
    },

    mounted() {
        this.getEvent();
    },

    methods: {

        selectProperty(property) {
            this.property = property;
            this.$store.commit('showModal', 'property-edit');
        },

        getEvent() {
            this.$store.commit('loading', true);
            EventApi.getEvent(this.$route.params.id)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.event = response.data.data;
                    this.params = { ...this.event };
                    this.$events.$emit('pageLoaded');
                })
                .catch(() => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

        updateEvent() {
            this.loading = true;
            EventApi.updateEvent(this.event.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                })
                .catch((error) => {
                    this.loading = false;
                    this.$store.commit('setAlertWithError', error);
                });
        },

    },

}

</script>
